export default __webpack_public_path__ + "static/media/instructions_1.f0a8b5b0.png";